"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableContainer = void 0;
var react_1 = __importDefault(require("react"));
exports.TableContainer = function (_a) {
    var children = _a.children;
    return react_1.default.createElement("div", null, children);
};
//# sourceMappingURL=TableContainer.js.map